<script>
/* globals axios route */

import ErrorHandler from '../../core/ErrorHandler';

export default {
  render() {
    return this.$scopedSlots.default({
      logout: this.logout,
    });
  },
  methods: {
    logout() {
      axios
        .post(route('logout'))
        .then(() => window.location.assign('/'))
        .catch(error => new ErrorHandler(error).dispatch());
    },
  },
};
</script>